export default ({ signup }, _, { t }) => {
  if (signup) {
    return t('sign_up_description');
  }
};
